import { useEffect } from 'react';
import { useUser } from 'hooks/useUser';
import { useButlletins } from 'hooks/corporatiu/useButlletins';
import Mosaic from 'components/corporatiu/Mosaic';
import DestacatButlleti from 'components/corporatiu/Butlletins/DestacatButlleti';
import styles from './mosaicbutlletins.module.scss';

const MosaicButlletins = (props) => {
    const { items } = props;
    const { isAuthenticated, accessToken } = useUser();
    const { getSubscripcionsButlletins } = useButlletins();

    useEffect(() => {
        if (isAuthenticated && accessToken) {
            getSubscripcionsButlletins();
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isAuthenticated, accessToken]);

    return (
        <>
            {items && (
                <div className={styles.mosaicButlletins}>
                    <Mosaic numColumns={3} numColumnsMobile={1} hGap={300} vGap={300} estilMosaic='butlletins'>
                        {items?.map((item, index) => (
                            <DestacatButlleti key={`slider-butlleti-${index}`} item={item} />
                        ))}
                    </Mosaic>
                </div>
            )}
        </>
    );
};

export default MosaicButlletins;
